module.exports = __webpack_public_path__ + "img/anglomama-mob.5f1be77f.jpg";